import { CommonModule } from '@angular/common';
import { Component, inject, input, OnInit, output } from '@angular/core';
import {
  NavSlimLinks,
  NavSlimLinksComponent
} from '@com-delta-idp/mnx-sitewide-header-ui';
import { HeaderSlimFacadeService } from '../../../data-access/facades/header-slim/header-slim-facade.service';
import { VacationHeaderFacadeService } from '../../../data-access/facades/header-slim/vacation-header/vacation-header-facade.service';

@Component({
  selector: 'idp-header-slim',
  standalone: true,
  imports: [CommonModule, NavSlimLinksComponent],
  templateUrl: './header-slim.component.html',
  styleUrls: ['./header-slim.component.scss']
})
export class HeaderSlimComponent implements OnInit {
  headerSlimFacadeService = inject(HeaderSlimFacadeService);
  vacationHeaderFacadeService = inject(VacationHeaderFacadeService);
  emptySlimNavContent = {} as NavSlimLinks;

  vacationHeader = input(false);
  shopHeader = input(false);
  startOverVacation = input(false);

  modifyButtonClicked = output<boolean>();
  startOverButtonClickedEvent = output();

  tripType = this.headerSlimFacadeService.tripType;

  onClick(event: boolean): void {
    this.modifyButtonClicked.emit(event);
  }

  startOverButtonClicked(): void {
    this.startOverButtonClickedEvent.emit();
  }

  ngOnInit(): void {
    if (this.shopHeader()) {
      this.headerSlimFacadeService.init();
    }
  }
}
